import { UtilActionReducer } from '../utils.action';
import { PayloadAction } from '../../../store/store.utils';
import { UtilState } from '../utils.state';
import { RbacUserPermissions } from '../../../../../common/models/rbac.interface';

export class GetUserPermissionsRequest extends UtilActionReducer {
    constructor() {
        super('Get RBAC User Permissions Request');
    }

    reduce(state: UtilState): UtilState {
        return {
            ...state,
            ui: {
                ...state.ui,
                loading: true
            }
        };
    }
}

export class GetUserPermissionsRequestSuccess
    extends UtilActionReducer
    implements PayloadAction<RbacUserPermissions>
{
    constructor(public readonly payload: RbacUserPermissions) {
        super('Get RBAC User Permissions Success');
    }

    reduce(state: UtilState): UtilState {
        let permissions = this.payload ? { ...this.payload } : {};

        /* If logged-in User is a SuperUser, then assign all permissions even if BE sends false */
        if (permissions.is_super_user === true) {
            permissions = {
                ...permissions,
                is_internal_user: true,
                is_manual_redeem_allowed: true,
                is_ss_account_status_change_allowed: true,
                is_ss_fraud_analysis_allowed: true,
                is_ss_associate_offers_allowed: true,
                is_ss_activate_offers_allowed: true,
                is_ss_transaction_view_allowed: true,
                is_ss_transaction_view_all_partners_allowed: true,
                is_ss_duplicate_transaction_view_allowed: true,
                is_ss_user_account_view_allowed: true,
                is_ss_user_account_modification_allowed: true,
                is_ss_offer_view_allowed: true,
                is_ss_view_payment_history_allowed: true,
                is_reprocess_payment_allowed: true,
                is_ss_continuity_adjustment_allowed: true,
                is_payment_review_allowed: true,
                is_transaction_review_allowed: true,
                is_offer_review_allowed: true,
                is_ss_user_deactivation_allowed: true,
                is_audit_trail_view_allowed: true
            };
        }

        return {
            ...state,
            ui: {
                ...state.ui,
                loading: false
            },
            data: {
                ...state.data,
                rbacPermissions: { ...permissions }
            }
        };
    }
}

export class GetUserPermissionsRequestFailure
    extends UtilActionReducer
    implements PayloadAction<any>
{
    constructor(public readonly payload: any) {
        super('Get RBAC User Permissions Failure');
    }

    reduce(state: UtilState): UtilState {
        return {
            ...state,
            ui: {
                ...state.ui,
                loading: false
            }
        };
    }
}
